<template>
  <component :is="component" />
</template>

<script>
import materialPLanOrderCheck from '../components/materialPLanOrderCheck.vue'
import materialPLanOrder from '../materialPLanOrder.vue'
export default {
  components: {
    materialPLanOrderCheck,
    materialPLanOrder
  },
  data() {
    return {
      component: 'materialPLanOrderCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'materialPLanOrderCheck' : 'materialPLanOrder'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/material-plan-manage/check/materialPLanOrderCheck.vue